export const WidgetListFields = [
  {
    key: 'isHideHeadRow',
    label: 'Hide columns',
  },
  {
    key: 'value',
    label: 'Value',
  },
]
